// extracted by mini-css-extract-plugin
module.exports = {"container":"Documents_container_3Bhw0"};